<template>
  <div class="col-lg-6 col-xl-4">
    <div class="portlet portlet--project">
      <div class="portlet-head">
        <h3><i class="far fa-sticky-note"></i> Deadlines, zamówienia, notatki</h3>
        <div
          v-if="
            getRole === 'manager' ||
            getRole === 'admin' ||
            getRole === 'superadmin'
          "
        >
          <b-dropdown right variant="outline-primary" size="sm" class="mb-0">
            <template v-slot:button-content>
              <i class="fas fa-plus"></i> Dodaj...
            </template>
            <b-dropdown-item-button variant="outline-primary" @click="addDate()">
              Deadline
            </b-dropdown-item-button>
            <b-dropdown-item-button variant="outline-primary" @click="addNote()">
              Notatka
            </b-dropdown-item-button>
            <b-dropdown-item-button variant="outline-primary" @click="addOrder()">
              Zamów u dostawcy
            </b-dropdown-item-button>
          </b-dropdown>
        </div>
        <div v-else>
           <b-button size="sm" variant="outline-primary"  @click="addNote()">Dodaj notatkę</b-button>
        </div>
      </div>
      <div class="portlet-body cs-scroll" style="padding: 0">
        <perfect-scrollbar>
          <ImportantEventsPortlet/>
          <SupplierOrdersPortlet :orders="supplier_orders" :constructionid="info.id"/>
          <NotesPortlet :notes="notes" :constructionid="info.id" />
        </perfect-scrollbar>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ImportantEventsPortlet from "@/components/notes/ImportantEventsPortlet";
import SupplierOrdersPortlet from "@/components/notes/SupplierOrdersPortlet";
import NotesPortlet from "@/components/notes/NotesPortlet";

export default {
  name: "DeadlinesOrdersNotesPortlet",
  components: { ImportantEventsPortlet, SupplierOrdersPortlet, NotesPortlet },
  props: {
    constructionid: { type: Number },
    notes: { type: Array },
    supplier_orders: { type: Array },
  },
  data() {
    return {
      selected: {},
    };
  },
  computed: {
    ...mapGetters("user", ["getRole"]),
    ...mapGetters("construction", ["info"]),
  },
  methods: {
    addDate() {
      this.$nextTick(() => {
        this.$bvModal.show("datesForm-modal");
      });
    },
    addNote() {
      this.$nextTick(() => {
        this.$bvModal.show("notesForm-modal");
      });
    },
    addOrder() {
      this.$nextTick(() => {
        this.$bvModal.show("supplierOrders-modal");
      });
    },
  },
};
</script>
